module.exports = __webpack_public_path__ + "static/media/8.960f2560.jpg";